import { getIntersectionRoot } from '@theme/scroll-container';

const footerObservers = new Map();
const pendingStrips = new WeakSet();

const mobileQuery = window.matchMedia('(max-width: 749px)');

window.addEventListener('submit', (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.matches('.proclad-footer__form')) return;

  const pageWrapper = document.querySelector('.page-wrapper');
  const scrollTop = pageWrapper && getComputedStyle(pageWrapper).overflowY !== 'visible'
    ? pageWrapper.scrollTop
    : window.scrollY;
  try {
    sessionStorage.setItem('proclad-newsletter-scroll', String(scrollTop));
  } catch (_) {
  }
}, { capture: true });

async function initFooterSwiper(strip) {
  if (pendingStrips.has(strip)) return;
  pendingStrips.add(strip);
  try {
    const { default: Swiper } = await import('@theme/swiper');
    if (!strip.isConnected || !mobileQuery.matches || strip.procladFooterSwiper) return;
    strip.procladFooterSwiper = new Swiper(strip, {
      slidesPerView: 'auto',
      spaceBetween: 16,
      grabCursor: true,
      watchOverflow: true,
      mousewheel: { forceToAxis: true },
    });
  } finally {
    pendingStrips.delete(strip);
  }
}

function syncProcladFooterSwipers() {
  document.querySelectorAll('[data-proclad-footer-swiper]').forEach((strip) => {
    if (!mobileQuery.matches) {
      footerObservers.get(strip)?.disconnect();
      footerObservers.delete(strip);
      strip.procladFooterSwiper?.destroy(true, true);
      strip.procladFooterSwiper = undefined;
      return;
    }
    if (strip.procladFooterSwiper || footerObservers.has(strip)) return;
    if (!('IntersectionObserver' in window)) {
      void initFooterSwiper(strip);
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      if (!entries.some((entry) => entry.isIntersecting)) return;
      observer.disconnect();
      footerObservers.delete(strip);
      void initFooterSwiper(strip);
    }, { root: getIntersectionRoot(), rootMargin: '400px 0px' });
    footerObservers.set(strip, observer);
    observer.observe(strip);
  });
}

syncProcladFooterSwipers();
mobileQuery.addEventListener('change', syncProcladFooterSwipers);
document.addEventListener('shopify:section:load', syncProcladFooterSwipers);



document.addEventListener('shopify:section:unload', (event) => {
  event.target.querySelectorAll('[data-proclad-footer-swiper]').forEach((strip) => {
    footerObservers.get(strip)?.disconnect();
    footerObservers.delete(strip);
    strip.procladFooterSwiper?.destroy(true, true);
    strip.procladFooterSwiper = undefined;
  });
});
